import { MatDialog } from '@angular/material/dialog';
import { IEntity, TemplateWorkflowConfig } from 'interfaces-lib';
import { WorkflowMessage, WorkflowStatusMessage } from 'interfaces-lib';
import { IGenerateDocumentWorkflowController } from '../template-list-view/template-workflow-types/igeneratedocumentworkflowcontroller';
import {
  IUserOverride,
  SectionFilesAttachmentPath,
  TemplateWorkflowContext,
} from '../template-list-view/template-workflow-types/templateworkflowcontext';
import { StageSet } from '../workflow-in-progress/workflow-in-progress.component';
import { ProgressReportingWorkflowTask } from './progress-reporting-workflow-task';

export class TemplateWorkflowTask extends ProgressReportingWorkflowTask {
  private static readonly STAGES: StageSet = {
    Started: { text: 'In-progress', icon: 'autorenew' },
    GettingWorkflowConfig: { text: 'Getting configuration', icon: '' },
    BuildingModel: { text: 'Building the model', icon: 'build_circle' },
    GeneratingDocument: {
      text: 'Generating the document',
      icon: 'document_scanner',
    },
    SaveToEntity: { text: 'Saving the document', icon: 'upload_file' },
    SimpleDocxComplete: { text: 'Success', icon: 'check_circle' },
  };

  constructor(
    private workflow: TemplateWorkflowConfig,
    private sourceEntity: IEntity,
    private destinationEntities: IEntity[],
    private attachments: SectionFilesAttachmentPath[],
    private taskController: {
      context: TemplateWorkflowContext;
      controller: IGenerateDocumentWorkflowController;
    },
    dialog: MatDialog
  ) {
    super(workflow.workflow, 'Generating Awesome Doc', TemplateWorkflowTask.STAGES, dialog, { startStage: 'Started' });
  }

  override getStartParams(): any {
    const sections = this.attachments.map((af) => {
      const section = { ...af.section };
      section.sourceValue = JSON.stringify(af.files);
      return section;
    });
    const destination = this.destinationEntities.map((value) => {
      return {
        namespace: this.workflow.clientNamespace,
        path: [value.type, value.id], // assumption that there is always a type and id. should be handled by namespace specific code?
      };
    });

    const override: IUserOverride = this.taskController.context.currentUserOverride;

    return {
      source: {
        namespace: this.workflow.clientNamespace,
        path: [this.sourceEntity.type, this.sourceEntity.id],
      },
      SOURCE_APPLICATION: "DOC_CLIENT",
      destination: destination,
      WORKFLOW_CONFIG_ID: this.workflow.id,
      CLIENT_ID: this.workflow.clientId,
      SECTIONS: sections,
      ...(override ?
        {
          CURRENT_USER_OVERRIDE_ID: override.id,
          CURRENT_USER_OVERRIDE_EMAIL: override.email
        } : {})
    };
  }

  override receive(message: WorkflowMessage): boolean {
    if (message.type === 'WorkflowStatus') {
      this.updateProgress(<WorkflowStatusMessage>message.message);
      return false;
    }

    if (message.type === 'ErrorEvent') {
      this.closeProgress();
      this.taskController.controller.documentGenerationError(this.taskController.context, message);
      return true;
    }

    if (message.type === 'options') {
      this.closeProgress();
      this.taskController.controller.documentGenerationSuccess(this.taskController.context, message);
      return true;
    }

    console.debug(`Message '${message.type}' not handled.`);

    return false;
  }
}
